import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Text } from "@sitecore-jss/sitecore-jss-react";
import PropTypes from "prop-types";

import classnames from "classnames";
import getUniqueId from "@assets/js/get-unique-id";
import { IMAGE, FILTER_NO_TYPE } from "@constants";
import ProductImage from "../../ProductImage";

import "./pdp-swatch-group.scss";
const PDPSwatchGroup = ({
  isActive,
  label,
  label2,
  label3,
  description,
  imageUrl,
  materials,
  isUnallowed,
  labelTranslationKey,
  itemTranslationKeySingular,
  itemTranslationKeyPlural,
  item,
  itemClickHandler,
}) => {
  const { t } = useTranslation();

  let texts = {
    itemsSingular: t(itemTranslationKeySingular),
    itemsPlural: t(itemTranslationKeyPlural),
    label: t(labelTranslationKey),
    other: t("FritzHansen_Project_ConsumersAndProfessionals_General_Other"),
  };
  
  const firstMeaningfullImgId = item.materials[0].materialId;
  const materialsCount = materials.length;
  const thumbsCount = materialsCount > 3 ? 3 : materialsCount;
  const additionalCount = materialsCount - thumbsCount;

  let countText;
  if (additionalCount > 0) {
    countText = `+${additionalCount} ${additionalCount === 1 ? texts.itemsSingular : texts.itemsPlural}`;
  } else {
    countText = `${materialsCount} ${
      materialsCount === 1 ? texts.itemsSingular : texts.itemsPlural
    }`;
  }

  const classList = classnames({
    "pdp-swatch-group": true,
    "is-active": isActive,
    "is-unallowed": isUnallowed,
  });
  return (
    <button className={classList} onClick={() => itemClickHandler(item)}>
      <div className="pdp-swatch-group__image">
        <ProductImage imageId={firstMeaningfullImgId} type={IMAGE.SWATCH} alt={label} sw="1275" cx="350" cy="350" ch="150" cw="300" />
        <span className="pdp-swatch-group__tag">
          <Text tag="span" field={{ value: label3 }} />
        </span>
      </div>
      <div className="pdp-swatch-group__info">
        <h4>
          <span>{label}</span>
        </h4>
        <footer>
          {materials.map((item, index) => {
            return (
              <Fragment key={getUniqueId()}>
                {index < thumbsCount && (
                  <span>
                    <ProductImage
                      imageId={item.materialId}
                      type={IMAGE.SWATCH}
                      alt={item.materialLabel}
                      sw="30"
                    />
                  </span>
                )}
              </Fragment>
            );
          })}
          <h5>{countText}</h5>
        </footer>
      </div>
    </button>
  );
};
PDPSwatchGroup.propTypes = {
  isActive: PropTypes.bool,
  isUnallowed: PropTypes.bool,
  label: PropTypes.string,
  label3: PropTypes.string,
  imageUrl: PropTypes.string,
  materials: PropTypes.array,
  item: PropTypes.object.isRequired,
  itemClickHandler: PropTypes.func.isRequired,
};

export default PDPSwatchGroup;
